exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".quickpanel {\n  width: 330px;\n  min-width: 330px;\n  max-width: 100vw;\n  height: 100%; }\n\n.overflow-container {\n  height: 100%;\n  overflow-x: hidden;\n  position: absolute;\n  width: 100%; }\n\n.overview {\n  padding: 24px; }\n\np {\n  color: #444;\n  margin: 0 0 12px; }\n\n.h1 {\n  font-size: 32px;\n  font-weight: 500;\n  margin-bottom: 0; }\n\nh4 {\n  color: #212121; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/web_clients/qualicheck.fr/preprod/erp/src/app/core/quickpanel/quickpanel.component.scss
// module id = ../../../../../src/app/core/quickpanel/quickpanel.component.scss
// module chunks = main